export default {
  label: 'Personnummer (ÅÅMMDDXXXX)',
  error: 'Ange ditt personnummer i rätt format'
}
